// src/utils/appearance.ts
import { outletScopeFor } from "../context/mountPointScopes.js";
function adaptAppearanceForJs(appearance, outlets) {
  if (!appearance) {
    return void 0;
  }
  const { icons, ...restAppearance } = appearance;
  const jsAppearance = { ...restAppearance };
  if (icons) {
    const jsIcons = {};
    const iconKeys = Object.keys(icons);
    for (const iconKey of iconKeys) {
      const reactRenderer = icons[iconKey];
      if (reactRenderer) {
        jsIcons[iconKey] = (el, props) => {
          return outletScopeFor(el, outlets).mount(el, reactRenderer, [props]);
        };
      }
    }
    jsAppearance.icons = jsIcons;
  } else {
    delete jsAppearance.icons;
  }
  return jsAppearance;
}
export {
  adaptAppearanceForJs
};
//# sourceMappingURL=appearance.js.map